/**
 * The four calls the app makes into Sentry, as a module singleton.
 *
 * This was a vue plugin - RavenVuePlugin - for one reason: installing it put the object on
 * the compat `Vue` global, and `Vue.raven.endpointException(...)` was how the resources and
 * the store modules reached it. None of that is vue. There is no `$raven` on the instance
 * and never was, so nothing here needs an app at all: the two dozen call sites import it.
 */
import Sentry from './raven';

const isSentryDSNSet = !!SENTRY_DSN;

// kept from the plugin: nothing in the bundle or the templates reads it, so this is here
// to be typed into a console on a live page
window.Sentry = Sentry;

const raven = {
    message (message, level = 'error') {
        if (isSentryDSNSet) {
            Sentry.captureMessage(message, {level: level});
        }
    },
    error (message) {
        this.message(message, 'error');
    },
    exception (e) {
        if (isSentryDSNSet) {
            Sentry.captureException(e);
        }
    },
    endpointException (name, error, level = 'warning') {
        error.name = 'endpointException';
        Sentry.captureException(new Error(name), {
            level: level,
            extra: error,
            tags: {eType: 'endpointException'}
        });
    }
};

export default raven;
